import "./App.css";
import React, { useEffect, useState } from "react";
import Todo from "./Todo";
import {
  Grid,
  makeStyles,
} from "@material-ui/core";
import db from "./firebase";
import firebase from "firebase";               
import Add from "./Add";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: 30,
  },
}));

function App() {
  // set state. States are temporary
  const [todos, setTodos] = useState([]);
    const classes = useStyles();

  // Listen to database and fetch new todos
  useEffect(() => {
    //this code fires when the app loads
    db.collection("todos")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        // console.log(snapshot.docs.map((doc) => doc.data()));
        setTodos(
          snapshot.docs.map((doc) => ({ id: doc.id, priority: doc.data().priority, name: doc.data().name, todo: doc.data().todo }))
        );
      });
  }, []);

  return (
    <div className="App">
      <h1>Osaiteh's To Do App!</h1>
      <Add />
      <Grid container className={classes.root} spacing={3}>
        {/* Loop through the array with map */}
        {todos.map((todo) => (
          <Todo todo={todo}  />
        ))}
      </Grid>
    </div>
  );
}

export default App;
